export const CHIP_BASE_CLASS = 'px-3 py-1.5 rounded-full text-sm border transition-colors';
export const CHIP_ACTIVE_CLASS = 'bg-champagne border-chocolate text-chocolate font-medium';
export const CHIP_INACTIVE_CLASS = 'border-champagne-dark text-text-medium hover:border-chocolate/60 hover:text-text-dark';
